import type { SupportedLanguage } from '@/i18n'

interface NewsTranslation {
  title: string
  excerpt: string
  content: string
}

export interface NewsArticle {
  slug: string
  date: string
  image: string
  translations: Record<SupportedLanguage, NewsTranslation> | { it: NewsTranslation; en: NewsTranslation }
}

/**
 * Get translation for a news article with fallback: lang → en → it
 */
export function getNewsTranslation(article: NewsArticle, lang: SupportedLanguage): NewsTranslation {
  const t = article.translations as Partial<Record<SupportedLanguage, NewsTranslation>>
  return t[lang] || t['en'] || article.translations['it']
}

export const newsArticles: NewsArticle[] = [
  {
    slug: 'fg-automazioni-crescita-2024',
    date: '2024-10-15',
    image: '/media/images/fg-azienda.jpg',
    translations: {
      it: {
        title: 'FG Automazioni continua a crescere: nuove opportunità nel settore dell’automazione',
        excerpt: 'Con oltre 11.925 progetti completati, FG Automazioni rafforza il proprio impegno nell’innovazione industriale e nell’espansione territoriale.',
        content:
          '<p>FG Automazioni annuncia un periodo di forte crescita, segnato dall’ampliamento delle unità locali e dall’ingresso di nuovi talenti nel team. Oggi siamo orgogliosi di contare 125 operatori altamente qualificati e di aver completato oltre 11.925 progetti in Italia e all’estero.</p><p>La nostra continua ricerca dell’eccellenza ci ha portati a investire nelle tecnologie 4.0, dall’intelligenza artificiale ai sistemi di visione, mantenendo al contempo la solida tradizione dell’automazione industriale che ci contraddistingue dal 1988.</p>',
      },
      en: {
        title: 'FG Automazioni continues to grow: new opportunities in the automation sector',
        excerpt: 'With over 11,925 completed projects, FG Automazioni strengthens its commitment to industrial innovation and territorial expansion.',
        content:
          '<p>FG Automazioni announces a period of strong growth, marked by the expansion of local units and the entry of new talents into the team. Today we are proud to count 125 highly qualified operators and to have completed over 11,925 projects in Italy and abroad.</p><p>Our continuous pursuit of excellence has led us to invest in Industry 4.0 technologies, from artificial intelligence to vision systems, while maintaining the solid tradition of industrial automation that has distinguished us since 1988.</p>',
      },
    },
  },
  {
    slug: 'visiofy-ai-controllo-qualita',
    date: '2024-06-20',
    image: '/media/images/visione.jpg',
    translations: {
      it: {
        title: 'VISIOFY.AI BIION-D: il nuovo standard per il controllo qualità in tempo reale',
        excerpt: 'Presentiamo VISIOFY.AI BIION-D, il sistema di visione artificiale che rivoluziona il controllo qualità nelle linee di produzione.',
        content:
          '<p>FG Automazioni lancia VISIOFY.AI BIION-D, una soluzione di visione artificiale in grado di analizzare in tempo reale i difetti in linea di produzione. Grazie ad algoritmi di deep learning, il sistema identifica anomalie con precisione millimetrica e genera report dettagliati per ottimizzare i processi produttivi.</p><p>La tecnologia è già stata adottata da diversi clienti del settore vetro cavo e legno, contribuendo a ridurre scarti e tempi di fermo macchina.</p>',
      },
      en: {
        title: 'VISIOFY.AI BIION-D: the new standard for real-time quality control',
        excerpt: 'We present VISIOFY.AI BIION-D, the machine vision system that revolutionizes quality control on production lines.',
        content:
          '<p>FG Automazioni launches VISIOFY.AI BIION-D, a machine vision solution capable of analyzing defects on production lines in real time. Thanks to deep learning algorithms, the system identifies anomalies with millimetric precision and generates detailed reports to optimize production processes.</p><p>The technology has already been adopted by several customers in the hollow glass and wood sectors, helping to reduce waste and machine downtime.</p>',
      },
    },
  },
]

export function getNewsBySlug(slug: string): NewsArticle | undefined {
  return newsArticles.find((a) => a.slug === slug)
}
